import { graphql } from 'react-apollo';
import gql from 'graphql-tag';
import { compose } from 'recompose';

import { querySelector } from '../../../utils';
import queryMetaHandler from '../../../utils/queryMetaHandler';
import omitProps from '../../../utils/omitProps';

const getEquipmentUsage = gql`
  query getEquipmentUsageQuery($startDate: String!, $endDate: String!, $equipmentId: Int!) {
    all_time_entries(start_date: $startDate, end_date: $endDate, equipment_id: $equipmentId) {
      edges {
        node {
          id
          equipment {
            id
            equipmentNumber: equipment_number
          }
          ticketNumber: ticket_number {
            id
            number
            ticket {
              id
              state
              job {
                id
              }
            }
          }
          date {
            display
          }
          timesheet {
            user {
              id
              firstname
              lastname
            }
          } 
        }  
      }
    }
  }
`;

const marshallData = ({ data, ownProps }) => {
  const allEquipmentUsage = querySelector(data, '$.all_time_entries.edges[*].node', []);
  const { loading } = data;
  return {
    ...ownProps,
    data,
    loading,
    allEquipmentUsage,
  };
};

const queryGetEquipmentUsageData = graphql(getEquipmentUsage, {
  props: marshallData,
});

export const queryGetEquipmentUsageDataGQL = compose(
  queryGetEquipmentUsageData,
  queryMetaHandler,
  omitProps(['data']),
);
